// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__15t_w","rootSmall":"AddTileButton_rootSmall__309a2"};